import React from "react";
import queryString from "query-string";
import { Form, Progress, Alert } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { WithLocalize } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from './img/logo.png'

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
class LoginForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.parameters = queryString.parse(props.location.search);
    this.parameters.idp = "cbv";
    this.ref = React.createRef();
    this.state = {
      onLogin: false,
      showForm: false,
      error: {
        open: false,
        message: "",
      },
      username: "",
      password: "",
    };
  }

  componentDidMount() {
    this.setState({ showForm: true });
  }

  onError(error) {
    this.setState({
      error: {
        open: true,
        message: error.message,
      },
    });
  }

  async onSubmit(ev) {
    ev.preventDefault();

    this.setState({
      onLogin: true,
      error: {
        open: false,
        message: "",
      },
    });

    this.props.api
      .userPassLogin(
        {
          username: this.usernameInput.value,
          password: this.passwordInput.value,
        },
        this.parameters
      )
      .then((response) => {
        this.setState({ onLogin: false });
        window.location =
          this.parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const translate = this.props.translate(error.errorCode);

        let message = "USUARIO NAO ENCONTRADO.";

        if (translate) {
          message = translate;
        } else if (error.details) {
          message = error.details;
        }
        this.setState({
          onLogin: false,
          error: { open: true, message: message },
        });
      });
  }

  render() {
    const { translate } = this.props;

    return (
      <CSSTransition
        in={this.state.showForm}
        timeout={300}
        classNames="formshow"
        nodeRef={this.ref}
        unmountOnExit
      >
        <div className="login-cbv-container" ref={this.ref}>
          <img src={logo} alt="logo" className="logo-cbv rounded mx-auto d-block" />
          <Form onSubmit={(event) => this.onSubmit(event)} className='cbv-login-body'>
            <input
              className="user-input-cbv"
              disabled={this.state.onLogin}
              placeholder={translate("PlaceholderUserName")}
              ref={(ref) => {
                this.usernameInput = ref;
              }}
              required={true}
              tabIndex={1}
              type="text"
              autoCorrect="off"
              autoCapitalize="none"
              id="username"
            />
            <i class="fa fa-user"></i>
            <input
              className="pass-input-cbv"
              required={true}
              disabled={this.state.onLogin}
              placeholder={translate("PlaceholderPassword")}
              ref={(ref) => {
                this.passwordInput = ref;
              }}
              tabIndex={1}
              type="password"
              autoCorrect="off"
              autoCapitalize="none"
              id="password"
            />
            <i class="fa fa-key"></i>
            {!this.state.onLogin ? (
              <button
                block={!this.parameters.failureRedirect}
                tabIndex={1}
                type="submit"
                id="submmit"
                className="enter-cbv btn-lg btn-block"
                disabled={!this.props.turnstileSuccess}
              >
                {translate("ButtonEnter")}
              </button>
            ) : (
              <Progress animated color="danger" value={100} />
            )}
            <div className="messages-container">
              <Alert
                color="danger"
                id="error-message"
                isOpen={this.state.error.open}
                toggle={() => this.setState({ error: { open: false } })}
              >
                {this.state.error.message}
              </Alert>
            </div>
            <this.props.TurnstileComponent setTurnstileSuccess={this.props.setTurnstileSuccess} />
          </Form>
        </div>
      </CSSTransition>
    );
  }
}

export default WithCaptcha(WithLocalize(LoginForm), { useInsideForm: true });
